<template>
  <layout-dashboard-card
    title="총 운행 시간"
    :value="Math.floor(statTime.total[0] / 60)"
    prepend-string="오늘"
    append-string="시간"
    :icon="icon"
    :width="350"
    :height="180">
    <template v-slot:extension>
      <div class="card-history-list d-flex justify-center">
        <table>
          <tr
            v-for="idx in 3"
            :key="`value_${idx}`">
            <td>{{ idx }}일전</td>
            <td class="card-history-list-value">{{ Math.floor(statTime.total[idx] / 60) }}시간</td>
          </tr>
        </table>
      </div>
    </template>
  </layout-dashboard-card>
</template>

<script>
import LayoutDashboardCard from '@/components/card/LayoutAccentCard.vue';
import Icon from '@/assets/icon_04.svg';
import { mapGetters } from 'vuex';

export default {
  name: 'CardTotalTime',
  components: {
    LayoutDashboardCard,
  },
  data: () => ({
    icon: Icon,
  }),
  computed: {
    ...mapGetters({
      statTime: 'stat/time',
    }),
  },
};
</script>

<style lang="scss" scoped>
.card-history-list {
  color: #9a9a9a;

  p {
    margin-bottom: 0;
  }

  table {
    .card-history-list-value {
      text-align: right;
      width: 48px;
    }
  }
}
</style>
